module.exports = "/packs/images/svg/geolocation~ef1a0c055ef3387297c398ebe6c91e09.svg";